var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/external-image-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["entry", "imageFields", "isLazy"], 
[], 
function (l_entry, l_imageFields, l_isLazy, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", l_entry);
frame.set("imageFields", l_imageFields);
frame.set("isLazy", l_isLazy);
var t_2 = "";var t_3;
t_3 = (l_isLazy?env.getFilter("append_param_string").call(context, runtime.memberLookup((l_imageFields),"primaryImageLinkToExternalUrl"),"qlt=" + "" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")):runtime.memberLookup((l_imageFields),"primaryImageLinkToExternalUrl"));
frame.set("imgSrc", t_3, true);
if(frame.topLevel) {
context.setVariable("imgSrc", t_3);
}
if(frame.topLevel) {
context.addExport("imgSrc", t_3);
}
t_2 += "\n    ";
var t_4;
t_4 = (l_isLazy?env.getFilter("append_param_string").call(context, runtime.memberLookup((l_imageFields),"alternateImageLinkToExternalUrl"),"qlt=" + "" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")):runtime.memberLookup((l_imageFields),"alternateImageLinkToExternalUrl"));
frame.set("altImgSrc", t_4, true);
if(frame.topLevel) {
context.setVariable("altImgSrc", t_4);
}
if(frame.topLevel) {
context.addExport("altImgSrc", t_4);
}
t_2 += "\n    ";
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"alternateText");
frame.set("altText", t_5, true);
if(frame.topLevel) {
context.setVariable("altText", t_5);
}
if(frame.topLevel) {
context.addExport("altText", t_5);
}
t_2 += "\n\n    ";
var t_6;
t_6 = (l_isLazy?"data-srcset":"srcset");
frame.set("srcSet", t_6, true);
if(frame.topLevel) {
context.setVariable("srcSet", t_6);
}
if(frame.topLevel) {
context.addExport("srcSet", t_6);
}
t_2 += "\n    ";
var t_7;
t_7 = (l_isLazy?"data-src":"src");
frame.set("src", t_7, true);
if(frame.topLevel) {
context.setVariable("src", t_7);
}
if(frame.topLevel) {
context.addExport("src", t_7);
}
t_2 += "\n\n    ";
if(!l_isLazy && (lineno = 17, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"experience.reduced"]))) {
t_2 += "\n        ";
var t_8;
t_8 = env.getFilter("append_param_string").call(context, runtime.contextOrFrameLookup(context, frame, "imgSrc"),"qlt=" + "" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality"));
frame.set("imgSrc", t_8, true);
if(frame.topLevel) {
context.setVariable("imgSrc", t_8);
}
if(frame.topLevel) {
context.addExport("imgSrc", t_8);
}
t_2 += "\n        ";
var t_9;
t_9 = env.getFilter("append_param_string").call(context, runtime.contextOrFrameLookup(context, frame, "altImgSrc"),"qlt=" + "" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality"));
frame.set("altImgSrc", t_9, true);
if(frame.topLevel) {
context.setVariable("altImgSrc", t_9);
}
if(frame.topLevel) {
context.addExport("altImgSrc", t_9);
}
t_2 += "\n    ";
;
}
t_2 += "\n\n    <picture data-qa-image-component>\n\n        ";
if(!(lineno = 24, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.thirdParty.moduleImages",runtime.contextOrFrameLookup(context, frame, "True")]))) {
t_2 += "\n\n            <img\n                style=\"width: 100%;\"\n                ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "src"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue((lineno = 28, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.thirdParty.moduleImageSrc",""])), env.opts.autoescape);
t_2 += "\"\n                alt=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "altText"), env.opts.autoescape);
t_2 += "\"\n                ";
if(l_isLazy) {
t_2 += " class=\"lazyload\" ";
;
}
t_2 += "\n                data-qa-external-image\n            />\n\n        ";
;
}
else {
t_2 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "altImgSrc")) {
t_2 += "\n\n                <source\n                    media=\"(min-width: 768px)\"\n                    ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcSet"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, runtime.contextOrFrameLookup(context, frame, "altImgSrc"),"fmt=webp"), env.opts.autoescape);
t_2 += "\" type=\"image/webp\" data-qa-external-alt-source/>\n\n                <source\n                    media=\"(min-width: 768px)\"\n                    ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcSet"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "altImgSrc"), env.opts.autoescape);
t_2 += "\"/>\n\n            ";
;
}
t_2 += "\n\n            <source\n                ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcSet"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, runtime.contextOrFrameLookup(context, frame, "imgSrc"),"fmt=webp"), env.opts.autoescape);
t_2 += "\" type=\"image/webp\" data-qa-external-primary-source/>\n\n            <img\n                ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "src"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "imgSrc"), env.opts.autoescape);
t_2 += "\"\n                alt=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "altText"), env.opts.autoescape);
t_2 += "\"\n                ";
if(l_isLazy) {
t_2 += " class=\"lazyload\" ";
;
}
t_2 += "\n                data-qa-external-image\n            />\n\n        ";
;
}
t_2 += "\n\n    </picture>";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("renderExternalPictureElement");
context.setVariable("renderExternalPictureElement", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/external-image-macro.j2"] , dependencies)